import AdminHeader from 'components/atoms/adminHeader';
import BreadCrumbsWeb from 'components/organisms/breadCrumbsWeb';
import NavigationHeaderWebTabs from 'components/organisms/navigationHeaderWebTabs';
import NavigationHeaderWeb from 'components/organisms/navigationWeb/index.web';
import {useTheme} from 'contexts/ThemeContext';
import {Flows, ScreenName, Screens} from 'navigations/Screens';
import React from 'react';
import {View, ScrollView} from 'react-native';
import styleSheet from './styles';

export interface AdminPanelUIProps {
  children?: JSX.Element;
  title: string;
  activeName: Flows | ScreenName;
  isGroupsInteraction?: boolean
}

const AdminPanelUI = (props: AdminPanelUIProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <ScrollView style={styles.container}>
      <NavigationHeaderWeb activeName={Flows.adminPanelGeneralFlow} />
      {props.isGroupsInteraction ? <BreadCrumbsWeb /> :<NavigationHeaderWebTabs activeName={props.activeName} />}
      <View style={styles.infoContainer}>
        <AdminHeader title={props.title} />
        {props.children}
      </View>
    </ScrollView>
  );
};

export default AdminPanelUI;
